import { useState, useEffect } from 'react';

export const useDebounce = (value: string, timeout: number = 500) => {
    const [state, setState] = useState<string>(value);
    useEffect(() => {
        const handler = setTimeout(() => setState(value), timeout);
        return () => clearTimeout(handler);
    }, [value, timeout]);
    return state;
}